import { Page } from '@codesuma/baseline'
import { PageHead } from '../page-head'
import style from './index.module.css'

// A full-page sheet on the neutral app-gray background that slides up from the
// bottom (baseline Page transition, driven by the router) and is dismissed with
// a back-chevron. Shared by the menu, about and privacy pages; callers append
// their content to the returned page.
export const SheetPage = (titleText?: string) => {
    const base = Page()
    base.addClass(style.base)
    // Inline so it wins over baseline's default page background/padding. The
    // calendar's own paper and ink, so a sheet reads as the same surface — and
    // in the seasons theme it carries the visible month's color like the rest.
    base.style({
        background: 'var(--paper)',
        color: 'var(--ink)',
        // --gutter comes from the stylesheet, which the head pulls back out of.
        padding: 'calc(var(--safe-top) + 0rem) var(--gutter) calc(var(--safe-bottom) + 0.5rem)',
    })

    // The app's one page head. A sheet is closed rather than stepped back out
    // of, so its chevron says so; a page whose title arrives with fetched data
    // sets it later through setTitle, and a page with no title at all puts
    // its own content in the heading instead.
    const head = PageHead(titleText, { label: 'بستن' })
    base.append(head)

    return Object.assign(base, { setTitle: head.setTitle, heading: head.heading })
}
